import React from 'react';

interface Metadata {
  title: string;
  description?: string;
  startDate?: string;
  endDate?: string;
  millLink?: string;
}

interface MetadataPanelProps {
  metadata: Metadata | null;
  onClose: () => void;
}

const MetadataPanel: React.FC<MetadataPanelProps> = ({ metadata, onClose }) => {
  console.log('Rendering MetadataPanel with:', metadata);
    
  if (!metadata) return null;

  return (
    <div
        style={{
        width: '100%',
        padding: '16px',
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        borderRadius: '6px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
        fontFamily: 'monospace',
        fontSize: '13px',
        zIndex: 1,
        }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '8px',
        }}
      >
        <strong>{metadata.title}</strong>
        <button
          onClick={onClose}
          style={{
            border: 'none',
            background: 'transparent',
            fontSize: '16px',
            cursor: 'pointer',
            marginLeft: '8px',
          }}
        >
          ✕
        </button>
      </div>

      <div style={{ marginTop: '8px' }}>{metadata.description || 'No description.'}</div>
      <div style={{ marginTop: '8px' }}>
        <div><strong>Start:</strong> {metadata.startDate || '—'}</div>
        <div><strong>End:</strong> {metadata.endDate || '—'}</div>
      </div>
      {metadata.millLink && (
        <div style={{ marginTop: '8px' }}>
          <a href={metadata.millLink} target="_blank" rel="noopener noreferrer">
            View in Mill ↗
          </a>
        </div>
      )}
    </div>
  );
};

export default MetadataPanel;